export default "__VITE_ASSET__BPwMIKFp__";